module.exports = __webpack_public_path__ + "static/img/Contact-info.cf26f35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Contact-info.png
// module id = jGXK
// module chunks = 36